(function () {
  const details = document.getElementById('header-search');
  const input = document.getElementById('header-search-input');
  const results = document.getElementById('header-search-results');

  if (!details || !input || !results) return;

  let timer;

  function clear() {
    results.replaceChildren();
  }

  function renderResult(item, price) {
    const link = document.createElement('a');
    link.href = item.url;
    link.className = 'header__search-result';

    if (item.image) {
      const img = document.createElement('img');
      img.src = item.image;
      img.alt = '';
      img.loading = 'lazy';
      link.appendChild(img);
    }

    const content = document.createElement('span');
    const title = document.createElement('span');
    title.className = 'header__search-result-title';
    title.textContent = item.title;
    content.appendChild(title);

    if (price) {
      const priceEl = document.createElement('span');
      priceEl.className = 'header__search-result-price';
      priceEl.textContent = price;
      content.appendChild(priceEl);
    }

    link.appendChild(content);
    results.appendChild(link);
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    const term = input.value.trim();

    if (term.length < 2) {
      clear();
      return;
    }

    timer = setTimeout(async function () {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6`,
        { headers: { Accept: 'application/json' } }
      );
      const data = await response.json();
      const resultsData = (data.resources && data.resources.results) || {};

      clear();

      (resultsData.products || []).forEach(function (product) {
        renderResult(product, '$' + parseFloat(product.price).toFixed(2));
      });

      if (!results.children.length) {
        const empty = document.createElement('p');
        empty.className = 'header__search-empty';
        empty.textContent = 'No results found.';
        results.appendChild(empty);
      }
    }, 200);
  });

  document.addEventListener('click', function (event) {
    if (!details.contains(event.target)) details.removeAttribute('open');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') details.removeAttribute('open');
  });
})();
